import { z } from 'zod';

import { orderLogsResultSchema, wireLogMsgTypeSchema } from '../orderLogs.mts';
import { AvaAIToolExecution } from '../toolExecution.mts';

export const getChildOrderLogsInputSchema = z.strictObject({
  childOrderId: z
    .string()
    .min(1)
    .describe(
      'A child order ID taken from another order-log result: the OID (for example 1T9M9GS6W6801), the venue OrderID, or the ClOrdID.'
    ),
  msgType: wireLogMsgTypeSchema,
});

export const getChildOrderLogsToolContract = {
  execution: AvaAIToolExecution.Server,
  name: 'getChildOrderLogs',
  inputSchema: getChildOrderLogsInputSchema,
  outputSchema: orderLogsResultSchema,
} as const;
